import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { customerService } from "../../services/customerService";

interface AccountState {
  balance: number | 0;
  errors: string | null;
  isLoading: boolean;
}

const initialState: AccountState = {
  balance: 0,
  errors: null,
  isLoading: false,
};

// Async thunks
export const fetchBalance = createAsyncThunk<number>(
  "payments/balance",
  async () => {
    const response = await customerService.getBalance();
    return response.data?.availableBalance;
  }
);




const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBalance.pending, (state) => {
        state.isLoading = true;
        state.errors = null;
      })
      .addCase(fetchBalance.fulfilled, (state, action) => {
        state.balance = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchBalance.rejected, (state, action) => {
        state.errors = action.error.message || "Failed to fetch balance";
        state.isLoading = false;
      })
     
  },
});

export default accountSlice.reducer;
